export default "__VITE_ASSET__BfKUOt5P__"